import { Shield, MapPin, Award } from "lucide-react";

const LocalAuthority = () => {
  return (
    <section className="bg-secondary border-t border-border/50 py-16 md:py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-white mb-12">
          Proudly Serving San Antonio &amp; Our Military Community
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {/* Column 1: JBSA Installations */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-4">
              <Shield className="w-6 h-6 text-primary flex-shrink-0" />
              <h3 className="text-lg md:text-xl font-semibold text-foreground">
                JBSA Installations
              </h3>
            </div>
            <ul className="space-y-2 text-muted-foreground text-sm sm:text-base">
              <li>Lackland AFB</li>
              <li>Fort Sam Houston</li>
              <li>Randolph AFB</li>
              <li>Camp Bullis</li>
            </ul>
            <p className="text-muted-foreground text-sm sm:text-base pt-2 border-t border-border/30">
              Official DBIDS credentialed door-to-door base access.
            </p>
          </div>

          {/* Column 2: San Antonio Hubs */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-4">
              <MapPin className="w-6 h-6 text-primary flex-shrink-0" />
              <h3 className="text-lg md:text-xl font-semibold text-foreground">
                San Antonio Hubs
              </h3>
            </div>
            <ul className="space-y-2 text-muted-foreground text-sm sm:text-base">
              <li>SAT Airport Terminal</li>
              <li>The Pearl District</li>
              <li>Hill Country Wineries</li>
              <li>Downtown / River Walk</li>
            </ul>
            <p className="text-muted-foreground text-sm sm:text-base pt-2 border-t border-border/30">
              Luxury black car service to every major destination.
            </p>
          </div>

          {/* Column 3: Local Directories & Certifications */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-4">
              <Award className="w-6 h-6 text-primary flex-shrink-0" />
              <h3 className="text-lg md:text-xl font-semibold text-foreground">
                Directories &amp; Certifications
              </h3>
            </div>
            <ul className="space-y-2 text-muted-foreground text-sm sm:text-base">
              <li>San Antonio Chamber of Commerce</li>
              <li>Local Veteran-Owned Business Directory</li>
              <li>TX DOT Certified Fleet</li>
            </ul>
            <p className="text-muted-foreground text-sm sm:text-base pt-2 border-t border-border/30">
              Verified, insured, and committed to excellence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalAuthority;
